import fetch from '@/api/fetch'
import { formatTime } from '@/utils/common.js'
export default {
    data() {
        return {
            orgList: [],
            // 撤回交卷
            subminPaperData: {
                planId: '',
                orgId: '',
                teamOrPlayer: ''
            },
            getSubminPaperData: {
                planList: [],
                teamOrPlayerList: []
            },
            // 重新绑定交卷
            resetPaperData: {
                planId: '',
                orgId: '',
                paperName: ''
            },
            getResetPaperData: {
                planList: []
            },
            majorList: [],
            // 重新评分
            resetScoreData: {
                majorId: '',
                paperId: '',
                orgId: '',
                times: [],
                planId: ''
            },
            getScoreData:{
                orgList: [],
                paperList: [],
                planList: []
            },
            pickerOptions: {
                disabledDate(time) {
                  // 获取当前日期
                  const now = new Date();
        
                  // 设置限制的最小日期
                  const minStartDate = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
        
                  // 设置限制的最大日期
                  const maxEndDate = new Date(now.getTime() + 90 * 24 * 60 * 60 * 1000);
        
                  // 如果选择的日期在限制范围内，返回 false（可选）
                  return time.getTime() < minStartDate.getTime() || time.getTime() > maxEndDate.getTime();
                },
              },
        }
    },
    created() {
        this.initList()
    },
    methods: {
        initList() {
            this.getAllOrgList()
            this.getMajors() // 获得专业列表
        },
        getMajors(){
            fetch.professionList().then(res => {
                if (res.code === '0') {
                    this.majorList = res.data
                }else {
                    this.$notify({ title: this.$t('testControl.CZ'), message: res.msg || this.$t('testControl.SJHQSB'), type: 'error' });
                }
            })
        },
        // 获取机构列表
        getAllOrgList() {
            fetch.allOrgList().then(res => {
                // console.log(res);
                if (res.code === '0') {
                    this.orgList = res.data
                } else {
                    this.$notify({ title: this.$t('testControl.CZ'), message: res.msg || this.$t('testControl.SJHQSB'), type: 'error' });
                }
            })
        },
        // 获取计划列表
        getPlanList(key, orgId) {
            fetch.allPlanList({ orgId }).then(res => {
                if (res.code === '0') {
                    this[key].planList = res.data
                } else {
                    this.$notify({ title: this.$t('testControl.CZ'), message: res.msg || this.$t('testControl.SJHQSB'), type: 'error' });
                }
            })
        },
        /// 获取团队或个人列表
        getTeamOrPlayer(key, planId) {
            fetch.allTeamOrPlayerNameList({ planId }).then(res => {
                if (res.code === '0') {
                    this[key].teamOrPlayerList = res.data.map(item => ({
                        ...item,
                        isTeam: item.teamId ? true : false,
                        teamIdOrPlayerId: item.teamId || item.playerId,
                        teamNameOrPlayerName: item.teamName || item.playerName
                    }))
                } else {
                    this.$notify({ title: this.$t('testControl.CZ'), message: res.msg || this.$t('testControl.SJHQSB'), type: 'error' });
                }
            })
        },
        // 获取试卷
        getPaperData(key, planId) {
            fetch.allPaperList({ planId }).then(res => {
                if (res.code === '0') {
                    this[key].paperName = res.data[0].paperName
                } else {
                    this.$notify({ title: this.$t('testControl.CZ'), message: res.msg || this.$t('testControl.SJHQSB'), type: 'error' });
                }
            })
        },
        // 获取试卷 重新评分
        getPaperList(key, majorId){
            fetch.getPaperList({
                professionId: majorId
            }).then(res => {
                if (res.code === '0') {
                    this[key].paperList = res.data
                }else{
                    this.$notify({ title: this.$t('testControl.CZ'), message: res.msg || this.$t('testControl.SJHQSB'), type: 'error' });
                }
            })
        },
        // 获取机构列表 重新评分
        getOrgList(key, paperId){
            fetch.orgList({
                paperId
            }).then(res => {
                if (res.code === '0') {
                    this[key].orgList = res.data
                }else{
                    this.$notify({ title: this.$t('testControl.CZ'), message: res.msg || this.$t('testControl.SJHQSB'), type: 'error' });
                }
            })
        },
        getPlanListScore(key){
            let { majorId,paperId,orgId, times  } = this.resetScoreData
            if(!times){
                return false
            }
            fetch.getPlanList({
                professionId: majorId, // --专业id
                paperId, // --试卷id
                orgId, // --机构id
                beginTime: times[0], // --开始时间
                endTime: times[1] // --结束时间
            }).then(res => {
                if (res.code === '0') {
                    this[key].planList = res.data
                }else{
                    this.$notify({ title: this.$t('testControl.CZ'), message: res.msg || this.$t('testControl.SJHQSB'), type: 'error' });
                }
            })
        },
        // 设置时间默认值
        setTimes(){
            let date = +new Date();
            let formattedDate = formatTime(date) + ':00'
            this.resetScoreData.times = [formatTime(date-7689600000) + ':00', formattedDate]
            this.handleDateChange();
            this.clearData('resetScoreData', 'planId');
        },
        // handelClick 
        handelClickButton(type, teamOrPlayer) {
            let { isTeam } = this.getSubminPaperData.teamOrPlayerList.find(
                item => item.teamId === teamOrPlayer || item.playerId === teamOrPlayer
            ) || {}
            let { majorId,paperId,orgId, times, planId } = this.resetScoreData
            let types = {
                CHSubmitPaper: {
                    info: this.$t('testControl.SFQRCHJJ'),
                    get: 'revertSubmit',
                    params: {
                        planId: this.subminPaperData.planId,
                        teamId: isTeam ? teamOrPlayer : undefined,
                        playerId: isTeam ? undefined : teamOrPlayer
                    },
                    key: 'subminPaperData'
                },
                paperReset: {
                    info: this.$t('testControl.SFQRCXBDSJ'),
                    get: 'planReBind',
                    params: {
                        planId: this.resetPaperData.planId
                    },
                    key: 'resetPaperData'
                },
                scoreReset:{
                    info: this.$t('testControl.SFQRCXPF'),
                    get: 'resourceReScore',
                    params: {
                        professionId: majorId, // --专业id
                        paperId, // --试卷id
                        orgId, // --机构id
                        planId, // --计划id
                        beginTime: times[0], // --开始时间
                        endTime: times[1] // --结束时间
                    },
                    key: 'resetScoreData'
                }
            }
            this.$confirm(types[type].info, this.$t('testControl.TS'), {
                confirmButtonText: this.$t('testControl.QD'),
                cancelButtonText: this.$t('testControl.QX'),
                type: 'warning'
            }).then(() => {
                fetch[types[type]['get']](types[type].params).then(res => {
                    if (res.code === '0') {
                        this.$notify({ title: this.$t('testControl.CZ'), message: res.msg || this.$t('testControl.CZCG'), type: 'success' });
                        // 重置数据
                        // try{
                        //     let keys = Object.keys(this[types[type].key])
                        //     keys.forEach(k=>{
                        //         this[types[type].key][k] = ''
                        //     })
                        // }catch(e){
                        //     this[types[type].key] = {}
                        //     console.log(e);
                        // }
                    }
                })
            }).catch((w) => {
                console.log(w);
                this.$notify({ title: this.$t('testControl.CZ'), message: this.$t('testControl.YQX'), type: 'info' });
            });
        },
        // 选择日期大于90天时，清空日期数组
        handleDateChange() {
            // 在日期选择变化时重置日期数组
            if (this.resetScoreData.times && this.resetScoreData.times.length === 2) {
                const [startDate, endDate] = this.resetScoreData.times;
                const diffInDays = (+new Date(endDate) - new Date(startDate)) / (24 * 60 * 60 * 1000);
                if (diffInDays > 90) {
                    // 如果选择的日期范围大于90天，清空日期数组
                    this.resetScoreData.times = [];
                    this.$notify({ title: this.$t('testControl.CZ'), message: this.$t('testControl.XZQJ'), type: 'warning' });
                }else{
                    this.getPlanListScore('getScoreData')
                }
            }
        },
        // 重置数据
        clearData(key, keyChild) {
            this[key][keyChild] = ''
        }
    }
}